export type ContactPersonTypeMessages = {
  individualOption: string;
  corporateOption: string;
};

export const CONTACT_PERSON_TYPE_MESSAGES: ContactPersonTypeMessages = {
  individualOption: "Pessoa Física",
  corporateOption: "Pessoa Jurídica",
};
